import styled from 'styled-components';
import colors from 'utils/colors';

const H3 = styled.span`
    font-size: 20px;
    font-weight: bold;
    line-height: 28px;
    color: ${props => props.color ? props.color : colors.black};
`;

export default H3;